import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';
import { wrapAuthFetch } from 'util/api';
import { updateShipValue, calculateTotalPriceForPromotion, selectPromotion } from 'model/cart';
import { openNormalAlert, openWarningAlert } from './alert';

const defaultCouponData = {
	UNUSED: [],
	USED: [],
	EXPIRED: [],
};

export const getCouponList = createAction('GET_COUPON_LIST', async () => {
	const { status, data } = await wrapAuthFetch('user/ec-coupons');

	if (status !== 200) {
		return { data: defaultCouponData };
	}

	return { data };
});

const addCoupon = createAction('ADD_COUPON', (series, typeIn) => async (dispatch, getState) => {
	const { status, data, message } = await wrapAuthFetch(`ec-coupons/${series}`, {
		method: 'POST',
		body: {},
	});

	if (status !== 200) {
		return { data: {}, message };
	}

	const price = calculateTotalPriceForPromotion(getState());
	const promotion = selectPromotion(getState());
	const promotionPrice = promotion.discount.length > 0 ? promotion.discount[0].discount : 0;
	const totalPrice = price - promotionPrice;

	if (typeIn === true) {
		if (data.coupon.threshold > totalPrice) {
			dispatch(openWarningAlert('不足折抵金額，本次訂單無法使用'));
			return { data: {} };
		}

		dispatch(openNormalAlert('兌換成功'));
		dispatch(getCouponList());

		dispatch(
			updateShipValue('coupon', {
				id: data.coupon.id,
				discount: data.coupon.discount,
				type: data.coupon.discount_type,
			}),
		);
	}

	dispatch(openNormalAlert('兌換成功'));
	dispatch(getCouponList());

	dispatch(
		updateShipValue('coupon', {
			id: data.coupon.id,
			discount: data.coupon.discount,
			type: data.coupon.discount_type,
		}),
	);
	return {
		data,
	};
});

const reducer = {
	coupon: handleActions(
		{
			GET_COUPON_LIST_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_COUPON_LIST_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				loading: false,
			}),
			ADD_COUPON_PENDING: state => ({
				...state,
				loading: true,
			}),
			ADD_COUPON_FULFILLED: (state, action) => ({
				...state,
				data: { ...state.data, ...action.payload.data },
				message: action.payload.message,
				loading: false,
			}),
		},
		{
			data: {
				USED: [],
				UNUSED: [],
				EXPIRED: [],
			},
			message: '',
			loading: false,
		},
	),
};

const mapHooksToStateByMessage = createSelector(
	state => state.coupon.message,
	message => message,
);

const mapHooksToStateByAllCoupon = createSelector(
	state => state.coupon.data,
	coupons => coupons,
);

export const useAddCoupon = () => useRedux(mapHooksToStateByMessage, { addCoupon });

export const useGetAllCoupon = () => useRedux(mapHooksToStateByAllCoupon, {});

export default { reducer };
